export default __webpack_public_path__ + "static/platform-documents-b1fa532efaf9a15613660c42b385b604.png";